import styled from 'styled-components';
import Layout from 'layouts/master-layout';
import { GetStaticProps } from 'next';
import YoutubeEmbed from 'components/youtube-embed';
import VideoItem from 'components/video-item';
import Button from 'components/button';
import { getLearnTVPage } from 'data/contentful-api';
import HeadlineBanner from 'components/headline-banner';
import { getVideoList } from 'data/youtube-api';
import { useRouter } from 'next/router';
import i18n, { SettingsType } from 'utils/i18n';

type TVPageProps = {
  data: FeedItem[];
  learnTVPage: LearnTVPagePage;
  videos: any;
};

export const TVNewPage: React.FC<TVPageProps> = ({ learnTVPage, videos }) => {
  const { query, locale } = useRouter();
  const { dictionary } = i18n[(locale as AcceptedLocales) || 'en-US'] as SettingsType;
  const queryId = (query?.id as string) || '';

  return (
    <Layout breadcrumb={[]} title={learnTVPage.title} description={learnTVPage.description}>
      <StyledTVArticle>
        <HeadlineBanner wide title={learnTVPage.title} subtitle={learnTVPage.description} />

        <div className="outer-padding modules-list">
          <ul className="tags">
            <li>
              <Button size="small" mode={'primary'} linkProps={{ href: `/videos` }}>
                {dictionary.browseAll}
              </Button>
            </li>

            {learnTVPage.videoSubpagesCollection.items
              .filter((item) => item !== null)
              .map((item) => {
                return (
                  <li key={item.slug}>
                    <Button size="small" mode={'secondary'} linkProps={{ href: `/videos/${item.slug}` }}>
                      {item.title}
                    </Button>
                  </li>
                );
              })}
          </ul>

          {queryId && <YoutubeEmbed id={queryId} />}

          <div className="videoes">
            {videos?.map((video) => {
              return <VideoItem video={video} key={video.id} />;
            })}
          </div>
        </div>
      </StyledTVArticle>
    </Layout>
  );
};

const StyledTVArticle = styled.section`
  margin-bottom: 3rem;

  .content {
    margin: 3rem 0;
  }

  .videoes {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1rem;
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin: 1rem 0;
  }
`;

export const getStaticProps: GetStaticProps<any> = async ({ locale }) => {
  const learnTVPage = await getLearnTVPage({ locale: locale as AcceptedLocales });
  const allFilteredVideos = learnTVPage?.videoSubpagesCollection.items
    .filter((item) => item !== null)
    .flatMap((subpage) =>
      subpage.videosCollection.items
        .filter((item) => item !== null)
        .map((videoItem) => ({
          ...videoItem,
          slug: subpage.slug,
        }))
    );
  const videos = await getVideoList(allFilteredVideos);

  return {
    props: {
      learnTVPage,
      videos: videos,
    },
    revalidate: 1,
  };
};

export default TVNewPage;
